// extracted by mini-css-extract-plugin
export default {"anticon":"iconStyle_anticon__lZlwx","anticon1":"iconStyle_anticon1__GGXP6","disabledBtn":"iconStyle_disabledBtn__XPBz6","disabledBtn2":"iconStyle_disabledBtn2__PfyZZ"};